import { styled } from "styled-components";

import { useDispatch, useMemoisedSelector, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { CustomTopicGrid } from "domains/customTopicGrid/CustomTopicGrid";
import { fetchFollowedTopics } from "entities/topics/actions";
import {
  createTopicsSelector,
  getFollowedTopicsHasPossibleNextPage,
  getFollowedTopicsIds,
  getFollowedTopicsIsPending,
} from "entities/topics/selectors";

const requestLimit = 6 * 8;

const StyledContainer = styled.div`
  padding-top: 3rem;
`;

export const FollowedTopicsPage = () => {
  const dispatch = useDispatch();
  const topics = useMemoisedSelector(getFollowedTopicsIds, createTopicsSelector);
  const isPossibleNextPage = useSelector(getFollowedTopicsHasPossibleNextPage);
  const isFetching = useSelector(getFollowedTopicsIsPending);
  const translate = useTranslate();

  const fetchTopics = (shouldInvalidate = false) => {
    const offset = shouldInvalidate ? 0 : topics.length;
    if (!isFetching) dispatch(fetchFollowedTopics({ limit: requestLimit, offset }));
  };

  return (
    <StyledContainer>
      <CustomTopicGrid
        fetchTopics={fetchTopics}
        isFetching={isFetching}
        isPossibleNextPage={isPossibleNextPage}
        title={translate("app.monitor.following_topics")}
        titleDataTestId="followed-topics-section-title"
        topicBack={{ term: "app.monitor.following_topics" }}
        topics={topics}
      />
    </StyledContainer>
  );
};
